<p>anzeigen-kondolenz-create works!</p>
<mat-card>
    <mat-form-field>
        <textarea matInput rows="5" cols="40" placeholder="Kondolenztext"></textarea>
    </mat-form-field>
    <button mat-button color="warn">Eintragen</button>
</mat-card>